/**
 * RequireBusinessProfile Guard
 *
 * Wraps routes that require a completed business profile.
 * Redirects to onboarding if profile is not complete.
 */

import { Navigate, Outlet } from 'react-router-dom';
import { useBusinessProfile } from '@/hooks/business/useBusinessProfile';

export function RequireBusinessProfile() {
  const { data: profile, isLoading } = useBusinessProfile();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          <p className="mt-4 text-gray-600">Loading business profile...</p>
        </div>
      </div>
    );
  }

  // If no profile, redirect to onboarding
  if (!profile) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
}

export default RequireBusinessProfile;
